import { Link, useLocation, useNavigate } from 'react-router-dom'
import { CheckCircle, Mail } from 'lucide-react'

export default function ForgotPasswordSent() {
  const location = useLocation() as { state?: { email?: string } }
  const navigate = useNavigate()
  const email = location.state?.email

  return (
    <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8" style={{ background: "linear-gradient(135deg, #36d1dc 0%, #5b86e5 100%)" }}>
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 text-center">
          <div className="mb-6 text-center">
            <div className="flex justify-center items-center gap-2">
              <a href="https://gotandem.ai" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:opacity-90">
                <img className="h-12 w-auto" src="/images/tandem-logo.svg" alt="Tandem" />
                <span className="text-2xl font-bold text-gray-900">Tandem</span>
              </a>
            </div>
            <h2 className="mt-4 text-2xl font-extrabold text-gray-900">Check your inbox</h2>
            <p className="mt-1 text-sm text-gray-600">
              If an account exists for {email ? <strong>{email}</strong> : 'that email'}, you'll receive a password reset link shortly.
            </p>
          </div>

          <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-3" />
          <div className="flex items-center justify-center text-gray-700 mb-6">
            <Mail className="w-5 h-5 mr-2" />
            <span>We sent a link to reset your password.</span>
          </div>
          <div className="space-y-3">
            <button onClick={() => navigate('/login')} className="w-full btn-primary">Back to sign in</button>
            <Link to="/forgot-password" className="w-full btn-secondary block text-center">Use a different email</Link>
          </div>
        </div>
      </div>
    </div>
  )
}
